/**
 * @author HungNS
 */
import Vue from "vue";
import Vuex from "vuex";
import dashboard from "./modules/dashboard/index.js";
import header from "./modules/header/index.js";
import news from "./modules/news/index.js";
import forceNews from "./modules/force-news/index.js";
import editProfile from "./modules/edit-profile/index.js";
import axios from "./modules/axios/index";
import leftMenu from "./modules/left-menu/index";
import cryptoRegistration from "@/store/modules/crypto-registration";
import Cookie from 'js-cookie';
import {v4} from 'uuid';
/* eslint-disable no-unused-vars */
const cookieName = 'my-page-cookie';

const storageKey = 'my-page-storage';

const encryptionToken = Cookie.get(cookieName) || v4();

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        header,
        dashboard,
        news,
        forceNews,
        editProfile,
        axios,
        leftMenu,
        cryptoRegistration
    },
});
